<template>
  <section v-if="activePopin">
    <p class="popin-text">
      {{ activePopin.description }}
    </p>
    <div
      class="popin-content"
      v-html="activePopin.content"
    />
    <rent-button
      @buttonclicked="onPopinClose"
      :href="activePopin.redirect_url"
      is-anchor
      :target="activePopin.open_in_new_tab == 0 ? '_self' : '_blank'"
    >
      {{ activePopin.button_text }}
    </rent-button>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import RentButton from '../shared/RentButton';

export default {
  components: {
    RentButton,
  },

  computed: {
    ...mapGetters({
      activePopin: 'popins/activePopin',
    }),

    isMobile() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) return true
      return false
    },
  },
  methods: {
    onPopinClose() {
      this.$emit('done', 'button')
    },

  },

};
</script>

<style scoped lang="scss">

section {
  display: flex;
  flex: 1;
  flex-direction: column;
  max-width: 330px;
  padding: 2rem;

  @include teq-breakpoint($medium) {
    max-width: 580px;
    padding: 7rem;
  }

  .popin-content {
    flex: 1;
  }

  ::v-deep .rent-button {
    flex-grow: 0;
  }

  ::v-deep b {
    font-family: $f-nouvel-r-bold;
  }

  .popin-text {
    font-family: $f-nouvel-r;
    font-size: 16px;
    line-height: 20.8px;
    margin: 0;

    @include teq-breakpoint($medium) {
      font-size: 22px;
      line-height: 20.9px;
    }

    &:nth-child(1) {
      padding-bottom: 3rem;
      padding-top: 70px;

      @include teq-breakpoint($medium) {
        padding-top: 0;
      }
    }
  }

  svg {
    height: 40px;
    margin-bottom: 40px;
    margin-top: 20px;

    @include teq-breakpoint($medium) {
      height: 70px;
      margin-bottom: 70px;
      margin-top: 20px;
    }
  }

  ::v-deep ul {
    li {
      margin-left: 1.5rem;

      &::before {
        color: $orange;
        content: "•";
        margin-right: 0.5rem;
      }
    }
  }
}
</style>
